import type { FC, MouseEvent } from 'react';
import * as styles from './InboxStatusButtons.css';
import { Box, Actions, Inline, Button, Hidden } from 'braid-design-system';
import ThumbsUpIcon from './ThumbsUpIcon';
import ThumbsDownIcon from './ThumbsDownIcon';
import { BUCKETS } from '../../../stores/JobApplicationStore/types';
import translations from './.vocab';
import { useTranslations } from '@vocab/react';

interface Props {
  idPrefix: string;
  fullName: string;
  onStatusChange: (bucket: BUCKETS) => void;
}

const InboxStatusButtons: FC<Props> = (props) => {
  const { t } = useTranslations(translations);
  const { idPrefix, fullName } = props;
  const createStatusChange = (bucket: BUCKETS) => {
    const { onStatusChange } = props;
    return (e: MouseEvent<HTMLElement> | undefined) => {
      if (e) {
        e.stopPropagation();
      }
      onStatusChange(bucket);
    };
  };

  return (
    <Box
      data-cy="inbox-status-buttons"
      data-testid="inbox-status-buttons"
      data-intercom-target="inbox-status-buttons"
      className={styles.wrapper}
    >
      <Actions>
        <Inline space="small" align="center">
          <Button
            variant="soft"
            aria-describedby={`${idPrefix}-button-not-suitable`}
            onClick={createStatusChange(BUCKETS.NOT_SUITABLE)}
            data={{ testid: 'mark-not-suitable' }}
          >
            <Box
              component="span"
              aria-label={t('Move fullName to Not Suitable', { fullName })}
              id={`${idPrefix}-button-not-suitable`}
            >
              <Inline space="none" align="center">
                <ThumbsDownIcon />
                <Hidden below="tablet">{t('Not Suitable')}</Hidden>
              </Inline>
            </Box>
          </Button>
          <Box
            className={styles.shortlistButton}
            component="button"
            aria-describedby={`${idPrefix}-button-shortlist`}
            onClick={createStatusChange(BUCKETS.SHORTLIST)}
            data-testid="mark-suitable"
          >
            <Box
              component="div"
              aria-label={t('Shortlist fullName', { fullName })}
              id={`${idPrefix}-button-shortlist`}
            >
              <Inline space="none" align="center">
                <ThumbsUpIcon />
                <Hidden below="tablet">{t('Shortlist')}</Hidden>
              </Inline>
            </Box>
          </Box>
        </Inline>
      </Actions>
    </Box>
  );
};

export default InboxStatusButtons;
